import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

// ADR-001 #13 — SPA mode. The router + queryClient are module-scope
// singletons consumed by src/main.tsx. The previous getRouter() factory
// was called per-request by TanStack Start's SSR scaffolding; with SSR
// dropped we don't need a factory.

export const queryClient = new QueryClient();

export const router = createRouter({
  routeTree,
  context: { queryClient },
  scrollRestoration: true,
  defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Backward-compat shim — anything still importing getRouter (e.g. the
// orphaned TanStack Start scaffold in src/start.ts) keeps working.
export const getRouter = () => router;
